export function tryParse(value = '', defaultValue) {
    try {
        return JSON.parse(value);
    } catch  {
        return defaultValue;
    }
}

//# sourceMappingURL=tryParse.js.map